/** @format */

import styled from 'styled-components';

export const AssetNotesContainer = styled.div`
  --border-color-gray: #d6dee4;
  --clr-yellow: #f0a642;
  --clr-green: #177d6b;
  --clr-blue: #0369a1;
  --clr-text: #111214;
  --clr-bg: #f6f8f9;

  margin-block: 0 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
`;

export const ElementContainer = styled.div<{ type: string }>`
  padding-block: 0.281rem;
  padding-right: 1rem;
  padding-left: 0.5rem;
  background-color: var(--clr-bg);
  color: var(--clr-text);
  border: 1px solid var(--border-color-gray);
  border-left: 4px solid
    var(
      ${({ type }) => {
        switch (type) {
          case 'info':
            return '--clr-blue';
          case 'positive':
            return '--clr-green';
          case 'warning':
            return '--clr-yellow';
        }
      }}
    );
  border-radius: 4px;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;

  p {
    margin: 0;
    text-wrap: initial;
  }
`;
